// Port dla konceptu "żywy" (t_3d96c476) z store-integration/preview/assets/pdp/pdp-wizard.js
// t_9b067a21: PDP = układ konceptu 4 (edytorialna kolumna + sticky panel) + wizard i lupa konceptu 7.
// Warstwa prezentacji nad product.js: przestawia istniejące węzły (ich listenery i stan zostają), czyta window.ALTIVEST_PRODUCT_STATE.
// Logika biznesowa (31 nici, 7 krojów, filtr treści, motywy, zapis, zapytanie, blokada zakupu) pozostaje w product.js bez zmian.
(() => {
  'use strict';
  const root = document.querySelector('.pdp-page[data-product-page]');
  const catalog = window.ALTIVEST_PRODUCT_DATA;
  if (!root || !catalog || !window.ALTIVEST_PRODUCT_STATE) return;
  const q = (s) => root.querySelector(s);
  const qa = (s) => [...root.querySelectorAll(s)];
  const native = root.dataset.native === 'true';
  const model = native ? root.dataset.model : ((window.AV_MODEL||new URLSearchParams(location.search).get('model')) || 'TSRA190');
  const product = catalog.products.find((p) => p.model === model);
  if (!product) return; // brak danych modelu: zostaje dotychczasowy komunikat product.js
  const man = product.manufacturer || {};
  const controls = q('[data-personalization-controls]');
  const form = q('[data-config-form]');
  const panel = q('.pdp-panel');
  if (!controls || !form || !panel) return;
  const hasProfile = Boolean(product.profileId) && !controls.hidden;
  const hasColors = Boolean(man.colors && man.colors.length);
  const hasSizes = Boolean(man.sizes && man.sizes.length);
  const S = () => window.ALTIVEST_PRODUCT_STATE;
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fineHover = matchMedia('(hover: hover) and (pointer: fine)');
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  const displayName = (() => { const t = product.shortTitle || String(product.title || '').replace(product.model, '').replace(/\s{2,}/g, ' ').trim(); return t || product.title; })();

  // ---------- wizard: stan kroku (wybory trzyma product.js) ----------
  const W = { active: 1, modeChosen: false, colorDeferred: false };
  const restored = /^Przywrócono/.test(q('[data-storage-note]')?.textContent || '');
  if (restored) { W.modeChosen = true; W.colorDeferred = true; }
  const skip3 = () => hasProfile && W.modeChosen && S().draft.mode === 'none';
  function done(n) {
    const s = S(); const d = s.draft; const miss = s.missingFields || [];
    // t_7d118e51: bez kolorów producenta krok 1 wymaga świadomego wyboru „Kolor ustalę w zapytaniu” (spójnie z produktami z próbkami).
    if (n === 1) return hasColors ? Boolean(d.color) : true;
    if (n === 2) return !hasProfile || W.modeChosen;
    if (n === 3) {
      if (!hasProfile) return true;
      if (!W.modeChosen) return false;
      if (d.mode === 'none') return true;
      return Boolean(s.textCheck && s.textCheck.ok) && !miss.includes('text') && !miss.includes('motif');
    }
    return (!hasSizes || Boolean(d.size)) && !miss.includes('quantity');
  }
  const unlocked = (n) => { for (let i = 1; i < n; i++) if (!done(i)) return false; return true; };
  const firstIncomplete = () => ORDER.find((n) => !done(n)) || ORDER[ORDER.length - 1]; // krok 1 przy jednym kolorze jest zawsze ukończony

  const titles = { 1: 'Kolor produktu', 2: 'Personalizacja', 3: 'Wzór, napis i nić', 4: 'Rozmiar i ilość' };
  const check = () => { const ns = 'http://www.w3.org/2000/svg'; const svg = document.createElementNS(ns, 'svg'); svg.setAttribute('viewBox', '0 0 16 16'); svg.setAttribute('aria-hidden', 'true'); const p = document.createElementNS(ns, 'path'); p.setAttribute('d', 'M3 8.5 6.5 12 13 4.5'); svg.append(p); return svg; };
  function makeStep(n) {
    const s = el('section', 'pdp-wz-step'); s.dataset.wzStep = String(n);
    const head = el('button', 'pdp-wz-head'); head.type = 'button'; head.dataset.wzHead = String(n); head.id = 'wz-head-' + n; head.setAttribute('aria-controls', 'wz-body-' + n);
    const num = el('span', 'pdp-wz-num'); num.setAttribute('aria-hidden', 'true'); num.append(el('span', 'pdp-wz-n', String(n).padStart(2, '0')), check());
    const tt = el('span', 'pdp-wz-title'); const name = el('span', 'pdp-wz-name', titles[n]); const sum = el('span', 'pdp-wz-sum'); sum.dataset.wzSum = String(n); tt.append(name, sum);
    const state = el('span', 'pdp-wz-state');
    head.append(num, tt, state);
    const body = el('div', 'pdp-wz-body'); body.id = 'wz-body-' + n; body.setAttribute('role', 'region'); body.setAttribute('aria-labelledby', head.id);
    s.append(head, body);
    return { n, s, head, body, sum, state, next: null };
  }
  const steps = { 1: makeStep(1), 2: makeStep(2), 3: makeStep(3), 4: makeStep(4) };
  // Kolejność widocznych kroków (bez kroku koloru przy jednym kolorze producenta).
  const ORDER = [1, 2, 3, 4].filter((n) => !(n === 1 && (man.colors || []).length <= 1) && !((n === 2 || n === 3) && !hasProfile)); const TOTAL = ORDER.length; root.dataset.wizardTotal = String(TOTAL);
  ORDER.forEach((n, i) => { steps[n].s.querySelector('.pdp-wz-n').textContent = String(i + 1).padStart(2, '0'); });

  // t_7d118e51: przycisk powstaje od razu jako nieaktywny (szary), render() go odblokowuje. Wcześniej pierwszy paint był czarny (:not(:disabled)) i przejście CSS zostawiało czarne tło.
  const addNext = (st, label) => { const b = el('button', 'pdp-wz-next', label); b.type = 'button'; b.disabled = true; b.dataset.wzNext = String(st.n); st.body.append(b); st.next = b; };

  const wz = el('div', 'pdp-wz'); wz.dataset.wizard = '';
  const progress = el('div', 'pdp-wz-progress');
  const pTop = el('div', 'pdp-wz-progress-top'); const pLabel = el('span', null); pLabel.dataset.wzLabel = ''; const pCount = el('span', null); pCount.dataset.wzCount = '';
  pTop.append(pLabel, pCount);
  const bar = el('div', 'pdp-wz-bar'); bar.setAttribute('role', 'progressbar'); bar.setAttribute('aria-label', 'Postęp konfiguracji'); bar.setAttribute('aria-valuemin', '0'); bar.setAttribute('aria-valuemax', String(TOTAL)); const fill = el('i'); bar.append(fill);
  progress.append(pTop, bar);

  // Krok 1: istniejące pola koloru (próbki + pełna lista producenta).
  const variant = q('.pdp-variant-fields');
  const sizeFieldset = q('[data-sizes]').closest('fieldset');
  const sizeGuide = variant.querySelector(':scope > [data-size-guide]');
  steps[1].body.append(variant);
  // t_852c0bc0: kolory jako próbki (swatche) zamiast listy nazw. Jedna siatka ze WSZYSTKIMI kolorami producenta
  // danego produktu (window.ALTIVEST_SWATCHES, hex z próbek na kartach PDF). Nazwa + kod w tooltipie/aria i w nagłówku po wyborze.
  // Natywny select zostaje ukrytym źródłem stanu dla product.js; stare próbki product.js (8 kodów) są zastępowane.
  const colorChoice = variant.querySelector('.pdp-color-choice');
  const colorSelect = variant.querySelector('[data-color]');
  const SW = (window.ALTIVEST_SWATCHES || {})[model] || [];
  const swInfo = new Map(SW.map((x) => [x.v, x]));
  // dopasowanie próbki po kodzie lub nazwie koloru, niezależnie od zapisu w panelu ("Black · BK", "BK", "Black")
  const swTok = (t) => String(t).toLowerCase().split(/\s*[·\/]\s*/).map((q) => q.trim()).filter(Boolean);
  // próbki z panelu (metaobiekt kolor_probki): wpis dla modelu ma pierwszeństwo przed wpisem ogólnym; brak wpisu = plik jako zapas
  const panelColors = (Array.isArray(window.AV_SHOP_COLORS) ? window.AV_SHOP_COLORS : []).filter((c) => c && c.kod && c.kolor);
  const forModel = (c) => String(c.modele || '').split(',').map((t) => t.trim().toLowerCase()).filter(Boolean);
  const pSpecific = panelColors.filter((c) => forModel(c).indexOf(String(model).toLowerCase()) >= 0);
  const pGeneral = panelColors.filter((c) => forModel(c).length === 0);
  const panelFind = (v) => {
    const full = String(v).toLowerCase().trim(); const parts = full.split(/\s*·\s*/); const code = parts[parts.length - 1].trim(); const first = parts[0].trim();
    const hit = (c) => { const k = String(c.kod).toLowerCase().trim(), n = String(c.nazwa || '').toLowerCase().trim(); return k === code || k === full || (n && (n === full || n === first)); };
    const c = pSpecific.find(hit) || pGeneral.find(hit);
    return c ? { v: c.kod, name: c.nazwa || c.kod, hex: c.kolor2 ? [c.kolor, c.kolor2] : c.kolor } : undefined;
  };
  const swFind = (v) => {
    const pc = panelFind(v); if (pc) return pc;
    if (swInfo.has(v)) return swInfo.get(v);
    const tk = swTok(v);
    for (const x of SW) { const xt = swTok(x.v).concat(x.name ? swTok(x.name) : []); if (tk.some((t) => xt.indexOf(t) >= 0)) return x; }
    return undefined;
  };
  const swBg = (x) => {
    if (!x || !x.hex) return '';
    if (x.pattern === 'camo') { const h = x.hex; const c = h.length > 3 ? h.slice(1) : h; const camo = 'radial-gradient(circle at 30% 35%,' + c[1] + ' 0 22%,transparent 23%),radial-gradient(circle at 72% 70%,' + c[1] + ' 0 20%,transparent 21%),radial-gradient(circle at 70% 25%,' + c[2] + ' 0 16%,transparent 17%),radial-gradient(circle at 25% 78%,' + c[2] + ' 0 15%,transparent 16%),' + c[0]; return h.length > 3 ? 'linear-gradient(135deg,' + h[0] + ' 0 50%,transparent 50%),' + camo : camo; }
    return Array.isArray(x.hex) ? 'linear-gradient(135deg,' + x.hex[0] + ' 0 50%,' + x.hex[1] + ' 50% 100%)' : x.hex;
  };
  const swLabel = (v) => { const x = swFind(v); if (!x) return v; const code = v.split(' · ')[0]; return x.name && x.name !== code ? x.name + ' · ' + code : x.name || code; };
  // t_dbe751a8: kolory główne klientki (maks. 8) jako widoczne próbki + multikolor „+” rozwijający pozostałe kolory
  // producenta (też jako próbki). Kolor spoza głównych = „dostępny na zamówienie”. Produkt z jednym kolorem: kolor
  // zaznaczony automatycznie, bez kroku wyboru koloru. Zdjęcia per kolor: window.ALTIVEST_COLOR_PHOTOS.
  const CP = ((window.ALTIVEST_COLOR_PHOTOS || {}).products || {})[model] || {};
  const allColors = hasColors && colorSelect ? [...colorSelect.options].map((o) => o.value).filter(Boolean) : [];
  const singleColor = allColors.length === 1;
  // kolory główne z panelu (pole produktu altivest.kolory_glowne); puste = lista z pliku (jak dotąd)
  const panelMain = (window.AV_SHOP_PRODUCT || {}).koloryGlowne;
  const cpParts = (x) => String(x).toLowerCase().split(' · ').map((t) => t.trim()).filter(Boolean);
  const mainSet = (Array.isArray(panelMain) && panelMain.length)
    ? new Set(allColors.filter((v) => panelMain.some((m) => { const pm = cpParts(m); return cpParts(v).some((t) => pm.indexOf(t) >= 0); })))
    : new Set((CP.main || []).filter((v) => allColors.includes(v)));
  const isOnOrder = (v) => Boolean(v) && mainSet.size > 0 && !mainSet.has(v);
  let orderNote = null;
  if (singleColor) {
    // Zdarzenie change dopiero po wstawieniu wizarda do DOM (product.js update() szuka pól w dokumencie).
    colorSelect.value = allColors[0];
    variant.classList.add('is-single-color');
    if (colorChoice) colorChoice.hidden = true;
    const nativeLabel = colorSelect.closest('label'); if (nativeLabel) nativeLabel.classList.add('pdp-color-native');
    W.active = 2;
    const sr = variant.querySelector('.pdp-swatches'); if (sr) { sr.hidden = true; if (sr.previousElementSibling && !sr.previousElementSibling.matches('input,select,button,label')) sr.previousElementSibling.hidden = true; }
  } else if (hasColors && colorSelect) {
    let swRow = variant.querySelector('.pdp-swatches');
    if (!swRow) { swRow = el('div', 'pdp-swatches'); (colorChoice || colorSelect.closest('label')).before(swRow); }
    swRow.replaceChildren();
    swRow.classList.add('pdp-swatch-grid'); swRow.setAttribute('role', 'group');
    const makeSw = (v) => {
      const x = swFind(v); const b = el('button'); b.type = 'button'; b.dataset.colorSample = v;
      const bg = swBg(x); if (bg) b.style.setProperty('--swatch', bg); else b.classList.add('is-nohex');
      if (x && /^#f[a-f0-9]{5}$/i.test(Array.isArray(x.hex) ? x.hex[0] : x.hex || '')) b.classList.add('is-light');
      const label = swLabel(v) + (isOnOrder(v) ? ' · na zamówienie' : ''); b.title = label; b.setAttribute('aria-label', label); b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', () => { colorSelect.value = v; colorSelect.dispatchEvent(new Event('change', { bubbles: true })); });
      return b;
    };
    const mainList = allColors.filter((v) => mainSet.has(v)).sort((a, b) => CP.main.indexOf(a) - CP.main.indexOf(b));
    const rest = allColors.filter((v) => !mainSet.has(v));
    const nativeLabel = colorSelect.closest('label'); if (nativeLabel) nativeLabel.classList.add('pdp-color-native');
    let expand = null; let multi = null;
    if (mainList.length && rest.length) {
      swRow.setAttribute('aria-label', 'Kolory główne (' + mainList.length + ')');
      mainList.forEach((v) => swRow.append(makeSw(v)));
      expand = el('div', 'pdp-color-more'); expand.id = 'pdp-color-more'; expand.hidden = true; expand.setAttribute('role', 'group');
      expand.setAttribute('aria-label', 'Więcej kolorów, na zamówienie (' + rest.length + ')');
      expand.append(el('p', 'pdp-color-more-t', 'Więcej kolorów · dostępne na zamówienie'));
      const grid = el('div', 'pdp-swatches pdp-swatch-grid'); rest.forEach((v) => grid.append(makeSw(v))); expand.append(grid);
      multi = el('button', 'pdp-swatch-multi'); multi.type = 'button'; multi.dataset.colorMulti = '';
      multi.setAttribute('aria-controls', expand.id); multi.setAttribute('aria-expanded', 'false');
      multi.setAttribute('aria-label', 'Więcej kolorów (' + rest.length + ')'); multi.title = 'Więcej kolorów (' + rest.length + ')';
      multi.addEventListener('click', () => { expand.hidden = !expand.hidden; multi.setAttribute('aria-expanded', String(!expand.hidden)); });
      swRow.append(multi); swRow.after(expand);
    } else {
      // Brak kolorów głównych albo brak pozostałych: jedna siatka (bez pustego rozwinięcia).
      swRow.setAttribute('aria-label', 'Kolory producenta (' + allColors.length + ')');
      allColors.forEach((v) => swRow.append(makeSw(v)));
    }
    orderNote = el('p', 'pdp-color-order'); orderNote.dataset.colorOrder = ''; orderNote.hidden = true; orderNote.setAttribute('aria-live', 'polite');
    orderNote.textContent = 'Kolor dostępny na zamówienie.';
    (expand || swRow).after(orderNote);
    if (colorChoice) { colorChoice.hidden = true; colorChoice.classList.add('pdp-color-expand'); }
    const heading = swRow.previousElementSibling;
    const syncSw = () => {
      const v = colorSelect.value;
      variant.querySelectorAll('[data-color-sample]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.colorSample === v)));
      const off = isOnOrder(v);
      if (multi) { multi.setAttribute('aria-pressed', String(off)); if (off && expand.hidden) { expand.hidden = false; multi.setAttribute('aria-expanded', 'true'); } }
      orderNote.hidden = !off;
      if (heading && !heading.matches('input,select,button,label')) heading.textContent = 'Kolor: ' + (v ? swLabel(v) + (off ? ' · na zamówienie' : '') : 'wybierz kolor');
    };
    // product.js ustawia nagłówek po swojej stronie w syncSamples; ten listener rejestrujemy później, więc wygrywa.
    colorSelect.addEventListener('change', syncSw); syncSw();
  }
  // Zdjęcia w wybranym kolorze (wizualizacje AI z tym samym kadrem co zdjęcie bazowe, więc pole haftu zostaje).
  // Realne zdjęcia z galerii z polem `color` (t_6c30f74b) mają pierwszeństwo: przy wybranym kolorze galeria pokazuje
  // realne zdjęcia tego koloru, a AI tylko tam, gdzie realnych brak.
  const base = { image: product.image, backImage: product.backImage };
  const colorPhotoNote = el('p', 'pdp-color-photo-note'); colorPhotoNote.hidden = true;
  const realFor = (v) => (product.gallery || []).filter((g) => g && g.color && g.color === v);
  // Kropki galerii: tylko widoczne zdjęcia, numeracja od nowa (także przed wyborem koloru: ukryte puste ujęcia nie mają kropek).
  function refreshDots() {
    const its = qa('[data-gallery-item]'); const dts = qa('[data-gallery-dots] button'); const vis = its.filter((x) => !x.hidden).length; let vi = 0;
    dts.forEach((d, i) => { const it = its[i]; d.hidden = !it || it.hidden; if (!d.hidden) { vi++; d.setAttribute('aria-label', 'Zdjęcie ' + vi + ' z ' + vis + ': ' + it.dataset.galleryLabel); } });
  }
  function applyColorPhotos(v) {
    const set = (CP.photos || {})[v] || null; const real = v ? realFor(v) : [];
    const hero = (set && (set.front || set.hero)) || (real[0] && real[0].image) || base.image; const back = (set && set.back) || base.backImage;
    product.image = hero; if (base.backImage) product.backImage = back;
    // t_9cf6a089: bez wybranego koloru i bez trybu personalizacji scena pokazuje oryginalne zdjęcie z modelem (leadImage).
    // Po wyborze trybu haftu scena przechodzi na packshot (pole haftu), a zdjęcie z modelem zostaje pierwsze w kolumnie.
    const pressedMode = q('[data-mode][aria-pressed="true"]'); const mode = pressedMode ? pressedMode.dataset.mode : 'none';
    const stage = q('[data-product-photo]'); const layer = q('[data-layer]');
    const backView = Boolean(layer && layer.dataset.view === 'back' && base.backImage);
    const lead = !(v && (set || real.length)) && product.leadImage && mode === 'none' && !backView ? product.leadImage : '';
    root.dataset.leadPhoto = lead ? 'true' : '';
    if (stage) {
      if (!stage.dataset.baseAlt) stage.dataset.baseAlt = stage.alt;
      const shown = backView ? back : (lead || hero); if (stage.getAttribute('src') !== shown) stage.src = shown;
      if (!backView) stage.alt = lead ? (product.leadImageAlt || stage.dataset.baseAlt) : stage.dataset.baseAlt;
    }
    const leadFig = q('[data-lead-item]'); if (leadFig) leadFig.hidden = Boolean(v && (set || real.length)) || Boolean(lead);
    // Wybrany kolor ze zdjęciami (realnymi lub AI): widać tylko zdjęcia tego koloru. Bez wyboru: galeria domyślna.
    const focus = Boolean(v) && Boolean(set || real.length);
    const seenPhotos = new Set([lead || hero]);
    qa('.pdp-ed-img').forEach((f) => {
      const img = f.querySelector('.pdp-ed-photo'); if (!img || f.dataset.leadItem !== undefined) return;
      const k = img.dataset.colorBase; const c = f.dataset.photoColor;
      if (c) { f.hidden = (focus && c !== v) || seenPhotos.has(img.getAttribute('src')); if (!f.hidden) seenPhotos.add(img.getAttribute('src')); return; }
      if (!k) { f.hidden = focus; return; }
      const next = set ? set[k] : null; const baseSrc = img.dataset.baseSrc || '';
      const src = next || (focus && allColors.length > 1 ? '' : baseSrc);
      f.hidden = !src || k === 'model' || seenPhotos.has(src); if (!f.hidden) seenPhotos.add(src); if (src && img.getAttribute('src') !== src) img.src = src;
    });
    refreshDots();
    root.dataset.colorPhoto = set || real.length ? v : '';
    const unavailable = false;
    if (stage) stage.closest('.pdp-stage').hidden = unavailable;
    let emptyPhoto = q('[data-photo-unavailable]');
    if (!emptyPhoto && stage) {
      emptyPhoto = el('p', 'pdp-color-photo-note', '');
      emptyPhoto.dataset.photoUnavailable = '';
      stage.closest('.pdp-stage').before(emptyPhoto);
    }
    if (emptyPhoto) emptyPhoto.hidden = !unavailable;
    product.cartImage = unavailable ? null : hero;
    colorPhotoNote.hidden = !unavailable;
    colorPhotoNote.textContent = '';
    window.dispatchEvent(new Event('scroll'));
  }
  let deferBtn = null;
  if (!hasColors) {
    steps[1].body.prepend(el('p', 'pdp-wz-info', 'Kolor ustalimy w zapytaniu. Karta producenta nie podaje wariantów kolorystycznych.'));
    variant.classList.add('is-no-colors'); // pusta lista producenta (zablokowany select) nie ma tu sensu
    deferBtn = el('button', 'pdp-color-name pdp-color-defer'); deferBtn.type = 'button'; deferBtn.dataset.colorDefer = '';
    deferBtn.append(el('span', 'pdp-color-name-t', 'Kolor ustalę w zapytaniu'));
    deferBtn.setAttribute('aria-pressed', String(W.colorDeferred));
    deferBtn.addEventListener('click', () => { W.colorDeferred = !W.colorDeferred; deferBtn.setAttribute('aria-pressed', String(W.colorDeferred)); });
    steps[1].body.append(deferBtn);
  }
  addNext(steps[1], 'Dalej');

  // t_dbe751a8: produkty bez pleców i piersi (kapelusz): miejsce „Przód”, bez opcji pleców.
  if (product.chestLabel) { const b = q('[data-placement="chest"]'); if (b) b.textContent = product.chestLabel; }
  if (product.noBackPlacement) { const b = q('[data-placement="back"]'); if (b) { b.hidden = true; b.disabled = true; } }
  // Kroki 2–3: istniejące kontrolki personalizacji.
  const modeFs = q('.pdp-mode'); const placeFs = q('[data-placement-field]');
  const textF = q('[data-text-fields]'); const motifF = q('[data-motif-field]');
  const modeDesc = { none: 'Sam produkt, bez haftu', text: 'Imię, napis lub data', motif: 'Gotowy wzór z biblioteki', both: 'Wzór i napis razem' };
  qa('.pdp-mode [data-mode]').forEach((b) => { const d = el('span', 'pdp-wz-mode-desc', modeDesc[b.dataset.mode] || ''); d.setAttribute('aria-hidden', 'true'); b.append(d); });
  if (hasProfile) {
    steps[2].body.append(modeFs, placeFs); addNext(steps[2], 'Dalej');
    steps[3].body.append(motifF, textF); addNext(steps[3], 'Dalej');
    controls.append(steps[2].s, steps[3].s);
  } else {
    const note = q('[data-profile-note]');
    steps[2].body.append(note || el('p', 'pdp-wz-info', 'Ten produkt nie ma zatwierdzonego profilu personalizacji.'));
    steps[2].body.append(el('p', 'pdp-wz-info', 'Personalizację i możliwość wykonania ustalimy w indywidualnym zapytaniu.'));
    steps[3].body.append(el('p', 'pdp-wz-info', 'Wzór, napis i kolor nici opiszesz w zapytaniu.'));
    addNext(steps[2], 'Dalej'); addNext(steps[3], 'Dalej');
  }

  // Krok 4: rozmiar + ilość. Przycisk zakupu (zablokowany) trafia do stałego podsumowania.
  const purchase = q('.pdp-purchase');
  const qtyLabel = purchase.querySelector(':scope > label');
  steps[4].body.append(sizeFieldset);
  // t_879317dc: „Przewodnik po rozmiarach” = miniatura tabeli wymiarów w tym miejscu, klik powiększa (dialog).
  const sizeTable = q('[data-size-table] table');
  if (sizeGuide && sizeTable) {
    // t_b942e84e: bez miniatury tabeli; zostaje sam przycisk przewodnika, który rozwija pełną tabelę w dialogu.
    const thumb = el('button', 'pdp-size-btn'); thumb.type = 'button'; thumb.dataset.sizeThumb = '';
    thumb.setAttribute('aria-haspopup', 'dialog');
    const plus = el('span', 'pdp-size-btn-icon', '+'); plus.setAttribute('aria-hidden', 'true');
    thumb.append(el('span', null, 'Przewodnik po rozmiarach'), plus);
    const dlg = el('dialog', 'pdp-size-dialog'); dlg.setAttribute('aria-label', 'Tabela wymiarów producenta');
    const dhead = el('div', 'pdp-size-dialog-head'); const close = el('button', 'pdp-size-dialog-close', 'Zamknij'); close.type = 'button';
    dhead.append(el('span', null, 'Przewodnik po rozmiarach'), close);
    const dbody = el('div', 'pdp-size-dialog-body'); dbody.append(sizeTable.cloneNode(true));
    const note = q('#rozmiary > p'); if (note) dbody.append(el('p', 'pdp-size-dialog-note', note.textContent));
    dlg.append(dhead, dbody); document.body.append(dlg);
    thumb.addEventListener('click', () => { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); close.focus(); });
    close.addEventListener('click', () => dlg.close ? dlg.close() : dlg.removeAttribute('open'));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', () => thumb.focus({ preventScroll: true }));
    sizeGuide.hidden = true;
    steps[4].body.append(thumb);
  } else if (sizeGuide) steps[4].body.append(sizeGuide);
  if (qtyLabel) { qtyLabel.classList.add('pdp-wz-qty'); steps[4].body.append(qtyLabel); }

  // t_dbe751a8: produkt z jednym kolorem nie ma kroku wyboru koloru (kolor zaznaczony automatycznie, widoczny nad krokami).
  if (singleColor) {
    steps[1].s.hidden = true;
    const one = el('p', 'pdp-wz-single'); one.dataset.singleColor = '';
    const x = swFind(allColors[0]); const bg = swBg(x);
    if (bg) { const i = el('i', 'pdp-wz-dot'); i.style.background = bg; one.append(i); }
    const lb = swLabel(allColors[0]).split(' · ').filter((t, i, a) => a.findIndex((x) => x.toLowerCase() === t.toLowerCase()) === i).join(' · ');
    one.append(el('span', null, 'Kolor: ' + lb));
    W.singleNode = one;
  }
  wz.append(progress, steps[1].s, hasProfile ? controls : steps[2].s);
  if (W.singleNode) progress.after(W.singleNode); // po wstawieniu do wizarda (węzeł odłączony nie ma rodzica)
  if (!hasProfile) wz.append(steps[3].s);
  wz.append(steps[4].s);
  form.prepend(wz);
  if (!hasProfile) controls.hidden = true;

  // Przyklejony dół panelu (koncept 4): CTA, status i zapytanie.
  // t_879317dc: lista KOLOR / HAFT / ROZMIAR I ILOŚĆ usunięta na prośbę Rafała (wybory widać w nagłówkach kroków).
  const summary = el('div', 'pdp-wz-summary'); summary.dataset.wzSummary = '';
  summary.append(purchase);
  const choice = q('[data-choice-summary]'); if (choice) summary.append(choice);
  ['[data-config-status]', '[data-prepare]'].forEach((s) => { const n = q(s); if (n) summary.append(n); });
  wz.after(summary);
  if (singleColor) colorSelect.dispatchEvent(new Event('change', { bubbles: true })); // t_dbe751a8: jedyny kolor zaznaczony
  // t_c91aff90: opis produktu nie stoi między CTA a szczegółami; idzie pod cenę jako krótki lead.
  const desc = q('[data-panel-description]');
  if (desc) { desc.classList.add('pdp-wz-lead'); const price = q('.pdp-price'); if (price) price.after(desc); }

  // ---------- podsumowania kroków ----------
  const threads = Array.isArray(catalog.threads) ? catalog.threads : [];
  const swatchFor = (color) => { const b = qa('[data-color-sample]').find((x) => x.dataset.colorSample === color); return b ? b.style.getPropertyValue('--swatch') : ''; };
  const dot = (hex, round) => { const i = el('i', 'pdp-wz-dot' + (round ? ' is-round' : '')); i.style.background = hex; return i; };
  const modeLabel = { none: 'Bez haftu', text: 'Tekst', motif: 'Motyw', both: 'Motyw + tekst' };
  function summaries() {
    const s = S(); const d = s.draft; const out = { 1: [], 2: [], 3: [], 4: [] };
    if (!hasColors) { if (W.colorDeferred) out[1] = ['Do ustalenia w zapytaniu']; }
    else if (d.color) { const hex = swatchFor(d.color); out[1] = [hex ? dot(hex) : null, swLabel(d.color)].filter(Boolean); }
    if (!hasProfile) { out[2] = ['Zapytanie indywidualne']; out[3] = ['Opis w zapytaniu']; }
    else if (W.modeChosen) {
      out[2] = [modeLabel[d.mode] + (d.mode === 'none' ? '' : ' · ' + (d.placementId === 'back' ? 'plecy' : (product.chestLabel || 'pierś').toLowerCase()))];
      if (d.mode === 'none') out[3] = ['Pominięty · bez haftu'];
      else {
        const parts = [];
        const motif = d.motifId && catalog.motifs.find((m) => m.id === d.motifId);
        if (motif) parts.push(motif.name);
        if (d.text && s.textCheck.ok) {
          parts.push('„' + d.text.replace(/\n/g, ' / ') + '”');
          const font = q('[data-font-chip][aria-pressed=true] .pdp-font-name'); if (font) parts.push(font.textContent);
          const th = threads.find((t) => t.id === d.threadId); if (th) { parts.push(dot(th.colorToken, true)); parts.push(th.name); }
        }
        out[3] = parts.flatMap((p, i) => (i && !(parts[i - 1] instanceof Element) ? [' · ', p] : [p]));
      }
    }
    if (!hasSizes) out[4] = [d.quantity + ' szt.'];
    else if (d.size) out[4] = [d.size + ' · ' + d.quantity + ' szt.'];
    return out;
  }

  // ---------- render ----------
  const hoverRefresh = new Set();
  function render(focusHead) {
    if (W.active === 3 && skip3()) W.active = 4;
    if (!ORDER.includes(W.active)) W.active = firstIncomplete();
    if (!unlocked(W.active)) W.active = firstIncomplete();
    const sum = summaries();
    let count = 0;
    for (const n of [1, 2, 3, 4]) {
      if (!ORDER.includes(n)) continue;
      const st = steps[n]; const isDone = done(n); const open = unlocked(n); const skipped = n === 3 && skip3();
      if (isDone) count++;
      st.s.classList.toggle('is-active', W.active === n);
      st.s.classList.toggle('is-done', isDone);
      st.s.classList.toggle('is-locked', !open);
      st.s.classList.toggle('is-skipped', skipped);
      st.head.setAttribute('aria-expanded', String(W.active === n));
      st.head.setAttribute('aria-disabled', String(!open));
      st.body.hidden = W.active !== n;
      st.sum.replaceChildren(...sum[n]);
      st.state.textContent = !open ? 'Zablokowany' : (W.active !== n && isDone ? 'Zmień' : '');
      // t_879317dc: zawsze mały przycisk „Dalej”; szary i nieaktywny do wyboru, potem czarny.
      if (st.next) { st.next.disabled = !isDone; st.next.textContent = isDone && n === 2 && skip3() ? 'Dalej: rozmiar' : 'Dalej'; }
    }
    steps[2].s.classList.toggle('is-unchosen', hasProfile && !W.modeChosen);
    const pos = ORDER.indexOf(W.active) + 1; const full = count === TOTAL;
    fill.style.width = (count * 100 / TOTAL) + '%'; bar.setAttribute('aria-valuenow', String(count));
    pLabel.textContent = full ? 'Gotowe do torby' : 'Krok ' + pos + ' z ' + TOTAL;
    pCount.textContent = count + '/' + TOTAL + ' ukończone';
    root.dataset.wizardStep = String(W.active); root.dataset.wizardDone = String(count);
    summary.classList.toggle('is-complete', full);
    dock.querySelector('span').textContent = full ? 'Gotowe do torby' : 'Krok ' + pos + ' z ' + TOTAL;
    if (focusHead) steps[W.active].head.focus({ preventScroll: true });
    hoverRefresh.forEach((fn) => fn());
  }
  function go(n, scroll) {
    W.active = n; render(true);
    if (scroll) steps[W.active].head.scrollIntoView({ block: 'nearest', behavior: reduce() ? 'instant' : 'smooth' });
  }
  Object.values(steps).forEach((st) => {
    st.head.addEventListener('click', () => { if (!unlocked(st.n)) return; go(st.n, false); });
    st.head.addEventListener('keydown', (e) => {
      const order = ORDER; const i = order.indexOf(st.n); let t = null;
      if (e.key === 'ArrowDown') t = order[Math.min(order.length - 1, i + 1)]; if (e.key === 'ArrowUp') t = order[Math.max(0, i - 1)];
      if (t == null) return; e.preventDefault(); steps[t].head.focus();
    });
  });
  wz.addEventListener('click', (e) => {
    const nb = e.target.closest('[data-wz-next]'); if (!nb) return;
    const n = Number(nb.dataset.wzNext); if (!done(n)) return;
    let next = ORDER[ORDER.indexOf(n) + 1] || 4; if (next === 3 && skip3()) next = 4;
    go(Math.min(4, next), true);
  });
  // Każda zmiana w panelu: product.js obsługuje ją na elemencie docelowym, potem (bubbling) odświeżamy wizard.
  const markMode = (e) => { if (e.target.closest && e.target.closest('[data-mode],[data-placement]')) W.modeChosen = true; };
  panel.addEventListener('click', (e) => { markMode(e); if (!e.target.closest('[data-wz-head],[data-wz-next]')) render(false); });
  ['input', 'change'].forEach((t) => panel.addEventListener(t, () => render(false)));
  // Wybór motywu poza panelem (sekcja wzorów, biblioteka) liczy się jako wybór trybu.
  root.addEventListener('click', (e) => {
    if (panel.contains(e.target)) return;
    if (e.target.closest('[data-motif-id]') && hasProfile) { W.modeChosen = true; if (unlocked(3)) W.active = 3; render(false); }
  });
  // Fokus wewnątrz treści innego (odblokowanego) kroku otwiera ten krok.
  panel.addEventListener('focusin', (e) => {
    const body = e.target.closest('.pdp-wz-body'); if (!body) return;
    const n = Number(body.closest('[data-wz-step]').dataset.wzStep);
    if (n !== W.active && unlocked(n)) { W.active = n; render(false); }
  });
  // „Przygotuj zapytanie” z brakami: product.js pokazuje komunikat, wizard otwiera właściwy krok.
  const prepare = q('[data-prepare]');
  if (prepare) prepare.addEventListener('click', () => {
    const s = S(); const miss = s.missingFields || [];
    const target = !s.textCheck.ok ? 3 : miss.length ? ({ color: 1, text: 3, motif: 3, size: 4, quantity: 4 }[miss[0]] || firstIncomplete()) : (hasProfile && !W.modeChosen ? 2 : null);
    if (target == null) return;
    const n = Math.min(target, firstIncomplete());
    W.active = n; render(false);
    const sel = { 1: '[data-color-sample],[data-color]', 2: '.pdp-mode [data-mode]', 3: '[data-text],[data-open-motifs]', 4: '[data-sizes] input,[data-quantity]' }[n];
    const f = steps[n].body.querySelector(sel); if (f) f.focus({ preventScroll: true });
    steps[n].head.scrollIntoView({ block: 'nearest', behavior: reduce() ? 'instant' : 'smooth' });
  });

  // ---------- mobile: przyklejony pasek do konfiguracji ----------
  const dock = el('button', 'pdp-wz-dock'); dock.type = 'button'; dock.hidden = true; dock.append(el('span'));
  dock.addEventListener('click', () => panel.scrollIntoView({ behavior: reduce() ? 'instant' : 'smooth', block: 'start' }));
  root.append(dock);
  const mobile = matchMedia('(max-width: 900px)');
  let panelVisible = true;
  const syncDock = () => { dock.hidden = !mobile.matches || panelVisible; };
  if ('IntersectionObserver' in window) new IntersectionObserver((es) => { panelVisible = es.some((x) => x.isIntersecting); syncDock(); }, { threshold: 0 }).observe(panel);
  mobile.addEventListener('change', syncDock);

  // ---------- kolumna zdjęć (t_37d0c2d5: same zdjęcia, bez wstawek tekstowych; kropki = aktywne zdjęcie) ----------
  const shell = q('.pdp-shell');
  const flow = el('div', 'pdp-ed-flow'); flow.dataset.edFlow = '';
  function figure(src, alt, o = {}) {
    const f = el('figure', 'pdp-ed-img'); f.dataset.galleryItem = ''; f.dataset.galleryLabel = alt;
    const fr = el('div', 'pdp-ed-frame' + (o.ratio ? ' ' + o.ratio : '')); fr.dataset.lensTarget = '';
    const img = new Image(); img.src = src; img.alt = alt; img.loading = 'eager'; img.decoding = 'sync'; img.className = 'pdp-ed-photo' + (o.fit === 'contain' ? ' is-contain' : '') + (o.crop ? ' is-crop' : '');
    if (o.crop) {
      const place = () => { const iw = img.naturalWidth || product.imageWidth || 1242; const ih = img.naturalHeight || product.imageHeight || 1560; const r = fr.clientHeight && fr.clientWidth ? fr.clientHeight / fr.clientWidth : 0.8; const Z = o.crop.z; const ar = ih / iw;
        const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
        const left = clamp(0.5 - o.crop.x * Z, 1 - Z, 0); const hRel = Z * ar / r; const top = clamp(0.5 - o.crop.y * Z * ar / r, 1 - hRel, 0);
        img.style.width = Z * 100 + '%'; img.style.left = left * 100 + '%'; img.style.top = top * 100 + '%'; };
      img.addEventListener('load', place); place(); if ('ResizeObserver' in window) new ResizeObserver(place).observe(fr);
    }
    fr.append(img);
    // Zastrzeżenie prawdziwości zostaje przy zdjęciu (etykieta w kadrze), nie jako tekst między zdjęciami.
    if (o.tag) { const t = el('span', 'pdp-ed-tag', o.tag); t.setAttribute('aria-hidden', 'true'); fr.append(t); }
    f.append(fr); return f;
  }
  // t_e75a7896: galeria główna = wyłącznie zdjęcia TEGO produktu. Bez zdjęć innych produktów (np. haft na poduszce)
  // i bez powtórzenia zdjęcia, które już stoi w scenie.
  const heroSrc = product.image;
  const box = Array.isArray(product.previewBox) ? product.previewBox : null;
  const tagBase = (f, k, src) => { const im = f.querySelector('.pdp-ed-photo'); im.dataset.colorBase = k; im.dataset.baseSrc = src; return f; };
  // t_dbe751a8: brakujące ujęcia bazowe (AI, ten sam styl co reszta) z pliku kolorów; dane podają je tylko dla produktów bez tych ujęć.
  const extraViews = ['front', 'back'].filter((k) => CP.baseViews && CP.baseViews[k]).map((k) => [k, CP.baseViews[k]]);
  // t_9cf6a089: oryginalne zdjęcie producenta z modelem (leadImage) jest pierwsze przed wyborem koloru; packshot przodu
  // (pole haftu, koszyk) trafia wtedy do kolumny zdjęć. Po wyborze koloru scena wraca do zdjęć tego koloru.
  const leadSrc = product.leadImage || '';
  const stageSrc = leadSrc || q('[data-product-photo]')?.getAttribute('src') || '';
  const seen = new Set((leadSrc ? [leadSrc] : [heroSrc, stageSrc]).filter(Boolean));
  // t_dbe751a8: zdjęcia realne przypisane do koloru (pole `color`) nie są ucinane limitem 8, bo filtr koloru je ukrywa.
  const gal = (product.gallery || []).filter((g) => g && g.image && !/-model\./.test(g.image) && !seen.has(g.image) && seen.add(g.image));
  // t_9cf6a089: gdy scena przejdzie na packshot (tryb haftu, widok tyłu), zdjęcie z modelem zostaje pierwsze w kolumnie.
  if (leadSrc) { const lf = figure(leadSrc, product.leadImageAlt || displayName, { fit: 'contain' }); lf.dataset.leadItem = ''; lf.hidden = true; flow.append(lf); }
  gal.filter((g, i) => g.color || gal.slice(0, i).filter((x) => !x.color).length < 8)
    // t_14c71cd2: wizualizacje AI (packshot) oznaczone uczciwie, nie jako fotografia źródłowa.
    .forEach((g) => {
      const f = g.kind === 'ai-visualization'
        ? figure(g.image, g.label, { fit: 'contain' })
        : figure(g.image, g.label, { fit: 'contain' });
      if (g.color) f.dataset.photoColor = g.color;
      else if (g.kind === 'ai-visualization') tagBase(f, /-model\.jpg$/.test(g.image) ? 'model' : /-back\.(?:jpg|webp)$/.test(g.image) ? 'back' : 'front', g.image);
      flow.append(f);
    });
  const viewName = { model: 'na modelu', front: 'przód', back: 'tył' };
  extraViews.forEach(([k, src]) => { if (!seen.has(src)) { seen.add(src); flow.append(tagBase(figure(src, displayName + ', ' + viewName[k], { fit: 'contain' }), k, src)); } });
  // Puste miejsca na ujęcia koloru, których galeria domyślna nie ma (np. przód/tył po podmianie AI na realne zdjęcia).
  const tagged = new Set([...flow.querySelectorAll('.pdp-ed-photo[data-color-base]')].map((i) => i.dataset.colorBase));
  ['front', 'back'].filter((k) => !tagged.has(k) && Object.values(CP.photos || {}).some((x) => x && x[k])).forEach((k) => {
    const f = figure('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7', displayName + ', ' + viewName[k], { fit: 'contain' });
    tagBase(f, k, ''); f.hidden = true; flow.append(f);
  });
  if (shell) shell.append(flow);
  const oldEditorial = q('.pdp-editorial'); if (oldEditorial) oldEditorial.hidden = true;

  // Kropki: jedna na zdjęcie (scena + kolumna), w przyklejonym pasie po lewej. Aktywna = zdjęcie najbliżej środka widoku.
  const stage = q('.pdp-stage');
  if (stage) { stage.dataset.galleryItem = ''; stage.dataset.galleryLabel = displayName + ': zdjęcie produktu'; }
  const items = qa('[data-gallery-item]');
  const pager = q('[data-gallery-dots]');
  if (pager && shell && items.length > 1) {
    const rail = el('div', 'pdp-gallery-rail'); rail.append(pager); shell.append(rail);
    const dots = items.map((it, i) => {
      const b = el('button'); b.type = 'button'; b.dataset.index = String(i); b.setAttribute('aria-label', 'Zdjęcie ' + (i + 1) + ' z ' + items.length + ': ' + it.dataset.galleryLabel); b.setAttribute('aria-current', String(i === 0)); b.append(el('span'));
      b.addEventListener('click', () => { setActive(i); it.scrollIntoView({ block: 'start', behavior: reduce() ? 'instant' : 'smooth' }); });
      pager.append(b); return b;
    });
    refreshDots(); // t_6b93b40f: ukryte ujęcia (np. puste miejsca na kolor) bez kropek od pierwszego załadowania
    let active = 0;
    function setActive(i) { if (i === active) return; active = i; dots.forEach((d, j) => d.setAttribute('aria-current', String(j === i))); root.dataset.galleryActive = String(i); }
    root.dataset.galleryActive = '0';
    let raf = 0;
    const sync = () => { raf = 0; const mid = innerHeight / 2 + (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--av-header')) || 72) / 2; let best = 0; let bestD = Infinity;
      items.forEach((it, i) => { const r = it.getBoundingClientRect(); if (!r.height) return; const d = r.top <= mid && r.bottom >= mid ? 0 : Math.min(Math.abs(r.top - mid), Math.abs(r.bottom - mid)); if (d < bestD) { bestD = d; best = i; } });
      setActive(best); };
    const queue = () => { if (!raf) raf = requestAnimationFrame(sync); };
    if ('IntersectionObserver' in window) { const io = new IntersectionObserver(queue, { threshold: [0, 0.25, 0.5, 0.75, 1] }); items.forEach((it) => io.observe(it)); }
    addEventListener('scroll', queue, { passive: true }); addEventListener('resize', queue);
    sync();
    // t_8d605688: bez dociągania do zdjęć (scroll-snap wyłączony na prośbę Rafała), przewijanie swobodne.
  } else if (pager) pager.hidden = true;

  // ---------- lupa (koncept 7): na zdjęciu głównym i zdjęciach kolumny ----------
  function attachLens(target, clone, zoom) {
    const lens = el('div', 'pdp-lens'); lens.setAttribute('aria-hidden', 'true'); const inner = el('div', 'pdp-lens-inner'); lens.append(inner); target.append(lens);
    let pt = null; let raf = 0;
    const size = () => { inner.style.width = target.clientWidth + 'px'; inner.style.height = target.clientHeight + 'px'; };
    const fillLens = () => { inner.replaceChildren(...clone()); size(); };
    const move = () => { raf = 0; if (!pt) return; const r = target.getBoundingClientRect(); const x = Math.max(0, Math.min(r.width, pt.x - r.left)); const y = Math.max(0, Math.min(r.height, pt.y - r.top)); const lw = lens.offsetWidth; const lh = lens.offsetHeight;
      lens.style.transform = 'translate(' + (x - lw / 2) + 'px,' + (y - lh / 2) + 'px)'; inner.style.transform = 'translate(' + (lw / 2 - x * zoom) + 'px,' + (lh / 2 - y * zoom) + 'px) scale(' + zoom + ')'; };
    target.addEventListener('pointerenter', (e) => { if (e.pointerType !== 'mouse' || !fineHover.matches) return; fillLens(); target.classList.add('is-lens'); pt = { x: e.clientX, y: e.clientY }; move(); });
    target.addEventListener('pointerleave', () => { target.classList.remove('is-lens'); pt = null; });
    target.addEventListener('pointermove', (e) => { if (e.pointerType !== 'mouse' || !target.classList.contains('is-lens')) return; pt = { x: e.clientX, y: e.clientY }; if (!raf) raf = requestAnimationFrame(move); });
    hoverRefresh.add(() => { if (target.classList.contains('is-lens')) fillLens(); });
  }
  const frame = q('.pdp-photo-frame');
  if (frame && heroSrc) attachLens(frame, () => {
    const img = frame.querySelector('[data-product-photo]').cloneNode(false); ['data-product-photo', 'fetchpriority', 'id'].forEach((a) => img.removeAttribute(a)); img.alt = ''; img.className = 'pdp-lens-photo';
    const layer = q('[data-layer]'); const out = [img];
    if (layer && !layer.hidden) { const c = layer.cloneNode(true); c.removeAttribute('data-layer'); c.classList.remove('is-changing'); c.querySelectorAll('[data-text-preview],[data-motif-preview]').forEach((x) => { x.removeAttribute('data-text-preview'); x.removeAttribute('data-motif-preview'); }); out.push(c); }
    return out;
  }, 2.4);
  qa('.pdp-ed-frame[data-lens-target]').forEach((fr) => attachLens(fr, () => { const c = fr.querySelector('.pdp-ed-photo').cloneNode(false); c.alt = ''; c.loading = 'eager'; return [c]; }, 2.2));

  if (colorSelect && hasColors && !singleColor) {
    (q('[data-color-order]') || variant).after(colorPhotoNote);
    colorSelect.addEventListener('change', () => applyColorPhotos(colorSelect.value));
  }
  applyColorPhotos(colorSelect ? colorSelect.value : '');
  // t_9cf6a089: zmiana trybu haftu lub widoku (przód/tył) przełącza scenę między zdjęciem z modelem a packshotem.
  if (product.leadImage) {
    let leadRaf = 0;
    const relead = () => { cancelAnimationFrame(leadRaf); leadRaf = requestAnimationFrame(() => applyColorPhotos(colorSelect ? colorSelect.value : '')); };
    const mo = new MutationObserver(relead);
    qa('[data-mode]').forEach((b) => mo.observe(b, { attributes: true, attributeFilter: ['aria-pressed'] }));
    const lay = q('[data-layer]'); if (lay) mo.observe(lay, { attributes: true, attributeFilter: ['data-view'] });
  }
  [1, 2, 3, 4].forEach((n) => { if (!ORDER.includes(n)) steps[n].s.hidden = true; });
  render(false);
  // t_252c503c: wariant produktu (np. pagony: Uczeń pilot, Pierwszy oficer, Kapitan). Zdjęcie sceny zmienia się z wariantem.
  if (product.variantOptions && Array.isArray(product.variantOptions.options) && product.variantOptions.options.length) {
    const vo = product.variantOptions; const box = el('fieldset', 'pdp-variant'); box.append(el('legend', '', vo.label || 'Wariant'));
    const row = el('div', 'pdp-variant-row'); box.append(row);
    const pick = (opt) => {
      root.dataset.variant = opt.id; root.dataset.variantLabel = opt.label;
      row.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.variantId === opt.id)));
      if (opt.image) {
        base.image = opt.image; product.image = opt.image; product.cartImage = opt.image;
        qa('[data-product-photo],[data-large-photo]').forEach((img) => { if (img.getAttribute('src') !== opt.image) img.src = opt.image; img.alt = (product.shortTitle || product.title) + ', ' + opt.label; });
        const cs = q('[data-color]'); applyColorPhotos(cs ? cs.value : '');
      }
      const qty = q('[data-quantity]'); if (qty) qty.dispatchEvent(new Event('input', { bubbles: true }));
    };
    vo.options.forEach((opt) => { const b = el('button', 'pdp-variant-btn', opt.label); b.type = 'button'; b.dataset.variantId = opt.id; b.addEventListener('click', () => pick(opt)); row.append(b); });
    const host = [4, 3, 2, 1].map((n) => steps[n] && steps[n].s).find((s) => s && !s.hidden);
    const body = host && host.querySelector('.pdp-wz-body'); if (body) body.prepend(box);
    pick(vo.options.find((o) => o.id === vo.default) || vo.options[0]);
  }
  // t_252c503c: infografika „Własny haft” przy opcji własnego haftu i wyceny indywidualnej. Bez strzałek, bez postaci.
  {
    const ic = {
      send: '<path d="M6 9h20v14H6z"/><path d="M6 9l10 8 10-8"/>',
      quote: '<path d="M9 5h11l5 5v17H9z"/><path d="M20 5v5h5M13 16h8M13 20h8M13 24h5"/>',
      hoop: '<circle cx="16" cy="16" r="10"/><circle cx="16" cy="16" r="7"/><path d="M12.5 17.5l2.5-5 2.5 5 2-3"/>'
    };
    const ig = el('div', 'pdp-own-haft'); ig.setAttribute('role', 'group'); ig.setAttribute('aria-label', 'Własny haft');
    ig.append(el('p', 'pdp-own-haft-title', 'Własny haft'));
    const ol = el('ol', 'pdp-own-haft-steps');
    [['send', 'Wyślij logo lub pomysł'], ['quote', 'Wycena i projekt'], ['hoop', 'Haft']].forEach(([k, t], i) => {
      const li = el('li', ''); li.innerHTML = '<span class="pdp-own-haft-ico" aria-hidden="true"><svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + ic[k] + '</svg><b>' + (i + 1) + '</b></span>';
      li.append(el('span', 'pdp-own-haft-label', t)); ol.append(li);
    });
    ig.append(ol);
    const s2 = steps[2] && steps[2].s; const modeSet = s2 && !s2.hidden && s2.querySelector('.pdp-mode');
    if (modeSet) modeSet.after(ig);
    else { const host = [4, 3, 1].map((n) => steps[n] && steps[n].s).find((s) => s && !s.hidden); const body = host && host.querySelector('.pdp-wz-body'); if (body) body.append(ig); }
  }
  window.ALTIVEST_PDP_WIZARD = { state: W, done, unlocked, render, go };
})();
